import { useCallback, useState } from 'react';
import { useDispatch } from 'react-redux';

import * as Api from '../../../../store/csw/csw.api';
import * as Actions from '../../../../store/csw/csw.actions';

export const useSavePackageSet = () => {
  const [shouldSaveNewPackageSet, setShouldSaveNewPackageSet] = useState(false);
  const toggleShouldSaveNewPackageSet = useCallback(() => {
    setShouldSaveNewPackageSet((should) => !should);
  }, []);

  const [packageSetName, setPackageSetName] = useState('');
  const onPackageSetNameChange = useCallback((e) => {
    setPackageSetName(e.target.value);
  }, []);

  const dispatch = useDispatch();
  const onSavePackageSet = useCallback(
    (packages) => {
      if (!shouldSaveNewPackageSet) {
        return;
      }
      const jsonData = JSON.stringify({ packages });
      const packageSet = {
        name: packageSetName,
        jsonData,
      };
      Api.savePackageSet(packageSet)
        .then((response) => {
          dispatch(Actions.savePackageSetSuccess(response));
        })
        .catch(() => {
          // TODO: handle error case
        });
    },
    [dispatch, packageSetName, shouldSaveNewPackageSet],
  );

  return {
    onPackageSetNameChange,
    onSavePackageSet,
    packageSetName,
    shouldSaveNewPackageSet,
    toggleShouldSaveNewPackageSet,
    setShouldSaveNewPackageSet,
  };
};
